// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"cN","reportCardBox":"cN","report-img-wrap":"cO","reportImgWrap":"cO","report-title":"cP","reportTitle":"cP","report-date":"cQ","reportDate":"cQ"};